import React, { useState } from "react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CustomCheckbox from "components/Checkbox";
import CustomButtonWithIcon from "components/CustomButtonWithIcon/Buttons";

const TermsDialog = ({ open, onClose, onAgree }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [accepted, setAccepted] = useState(false);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        Terms and Conditions
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{maxHeight: '450px', overflowY: 'auto', marginBottom: '10px', fontSize: '12px'}}>
          By enabling AI Connect, you authorize Cendyn to share your Availability, Rates, and Inventory (ARI) data for all properties you can access in your DMP account
          with participating AI channels for discovery and booking.
          Your ARI may be distributed to multiple AI partners, and you agree to pay Cendyn a 5% commission on each reservation attributed to an AI channel.
          ARI will only be shared after you set the channel to Open in DMP.
        </DialogContentText>
        <CustomCheckbox
          fontSize={14}
          size="medium"
          title={"I accept the Terms and Conditions"}
          checked={accepted}
          onChange={(e, checked) => setAccepted(checked)}
        />
      </DialogContent>
      <DialogActions>
        <CustomButtonWithIcon
          color="#b0acac"
          hoverColor="#12794F"
          titleColor="#373F41"
          hoverTitleColor={"white"}
          width={"85px"}
          height={"24px"}
          borderRadius="20px"
          textStyle={{
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "14.52px",
            textAlign: "center",
          }}
          onClick={onClose}
        >
          Disagree
        </CustomButtonWithIcon>
        <CustomButtonWithIcon
          color="#b0acac"
          hoverColor="#12794F"
          titleColor="#373F41"
          hoverTitleColor={"white"}
          width={"85px"}
          height={"24px"}
          borderRadius="20px"
          textStyle={{
            fontFamily: "Inter",
            fontSize: "12px",
            fontWeight: 500,
            lineHeight: "14.52px",
            textAlign: "center",
          }}
          autoFocus
          disabled={!accepted}
          onClick={onAgree}
        >
          Agree
        </CustomButtonWithIcon>
      </DialogActions>
    </Dialog>
  );
};
export default TermsDialog;
